import { render, staticRenderFns } from "./ActivityPermissionGroups.vue?vue&type=template&id=2b0f64a1"
import script from "./ActivityPermissionGroups.vue?vue&type=script&lang=js"
export * from "./ActivityPermissionGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports